module.exports = __webpack_public_path__ + "img/draw_contact_us.5cb6e721.png";